import Head from 'next/head';

import Profile from '../../src/legacy/components/pages/Profile/Profile';

export const ProfilePage = (): JSX.Element => (
  <div className="container mx-auto">
    <Head>
      <title>Profile | Bounce</title>
      <meta property="og:type" content="website" />
      <meta property="fb:app_id" content="1855802768063770" />
    </Head>

    <Profile />
  </div>
);

export default ProfilePage;
